import './form.scss';

import * as React from 'react';
import { Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { actions, Control } from 'react-redux-form';
import Select from 'react-select';

import { dispatch, ModelContext } from '../../../utils/generalUtils';

export interface IRRFInputProps {
    id: string;
    type: string;
    model: string;
    placeholder: string;
    label?: string;
    defaultValue?: string;
    onChange?: (value) => void;
    className?: string;
    emptyFieldModel?: string;
    disabled?: boolean;
    formmodel?: string;
    menuItems?: {
        label: string;
        value: string;
    }[];
    multi?: boolean;
    onSelect?: (obj) => void;
}

export interface IRRFInputState {
    selectedOption: string;
    modelName: string;
    newArray: string[];
    value: string;
}
export class RRFInputImpl extends React.Component<IRRFInputProps, IRRFInputState> {
    constructor(props: IRRFInputProps) {
        super(props);
        const modelName = `${this.props.formmodel}${this.props.model}`;
        this.state = {
            value: (props.defaultValue || ''), selectedOption: props.defaultValue || '', modelName, newArray: []
        };
        dispatch(actions.change(modelName, (props.defaultValue || '')));
    }

    componentWillReceiveProps(nextProps: IRRFInputProps) {
        if (nextProps.type === 'dropdown' && nextProps.defaultValue &&
            (nextProps.defaultValue !== this.props.defaultValue)) {
            this.setState({
                selectedOption: nextProps.defaultValue,
            });
        } else if (nextProps.defaultValue && !this.state.value) {
            this.setState({
                value: nextProps.defaultValue,
                newArray: []
            });
            dispatch(actions.change(this.state.modelName, (nextProps.defaultValue || '')));
        } else if (nextProps.defaultValue !== this.props.defaultValue) {
            this.setState({
                value: nextProps.defaultValue,
            });
            dispatch(actions.change(this.state.modelName, (nextProps.defaultValue || '')));
        }
    }

    handleOnChange = (e) => {
        this.setState({
            value: e.target.value
        });
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    handleChange = (obj, modelName) => {
        const { multi, onSelect } = this.props;
        if (obj && !multi) {
            this.setState({
                selectedOption: obj.label
            });
            dispatch(actions.change(modelName, obj.value));
        }
        if (obj instanceof Array) {
            const newArray = [];
            obj.forEach(option => {
                if (option) {
                    newArray.push(option.value);
                }
            });
            this.setState({
                selectedOption: newArray.toString(), newArray
            });
            if (obj.length > 0) {
                dispatch(actions.push(modelName, obj[obj.length - 1].value));
            }
        }
        if (onSelect) {
            onSelect(obj);
        }
    }

    renderInputComponent = (type, modelName) => {
        const { id, label, className, disabled, placeholder,
            onChange, model, emptyFieldModel, menuItems, multi } = this.props;
        switch (type) {
            case 'text':
                return <Row className="show-grid input-container">
                    <Col sm={4} xs={12} className="input-label" >
                        <label key={1} htmlFor={id} >{label}</label>
                    </Col>
                    <Col sm={8} xs={12} className="input-field" >
                        <Control.text
                            key={2}
                            type="text"
                            model={`${modelName}${model}`}
                            className={`form-control ${emptyFieldModel === model ? 'empty-field' : ''}  ${className}`}
                            onChange={this.handleOnChange}
                            placeholder={placeholder}
                            disabled={disabled}
                            value={this.state.value}
                        />
                    </Col>
                </Row>;
            case 'textarea':
                return <Row className="show-grid input-container">
                    <Col sm={4} xs={12} className="input-label" >
                        <label key={1} htmlFor={id} >{label}</label>
                    </Col>
                    <Col sm={8} xs={12} className="input-field" >
                        <Control.textarea
                            key={2}
                            rows={3}
                            model={`${modelName}${model}`}
                            className={`form-control ${emptyFieldModel === model ? 'empty-field' : ''}  ${className}`}
                            onChange={this.handleOnChange}
                            placeholder={placeholder}
                            value={this.state.value}
                            disabled={disabled}
                        />
                    </Col>
                </Row>;
            case 'dropdown':
                return <Row className="show-grid input-container">
                    <Col sm={4} xs={12} className="input-label" >
                        <label key={1} htmlFor={id} >{label}</label>
                    </Col>
                    <Col sm={8} xs={12} className="input-field" >
                        <Select
                            className=""
                            value={this.state.selectedOption}
                            onChange={obj => this.handleChange(obj, `${modelName}${model}`)}
                            options={menuItems}
                            multi={multi}
                            clearable={false}
                            placeholder={placeholder}
                        />
                    </Col>
                </Row>;

            default:
                return <Row className="show-grid input-container">
                    <Col sm={4} xs={12} className="input-label" >
                        <label key={1} htmlFor={id} >{label}</label>
                    </Col>
                    <Col sm={8} xs={12} className="input-field" >
                        <Control.text
                            key={2}
                            type={type}
                            model={model}
                            className={`form-control ${emptyFieldModel === model ? 'empty-field' : ''}  ${className}`}
                            onChange={this.handleOnChange}
                            placeholder={placeholder}
                            disabled={disabled}
                            value={this.state.value}
                        />
                    </Col>
                </Row>;
        }
    }

    render() {
        return <ModelContext.Consumer  >
            {modelName => this.renderInputComponent(this.props.type, modelName)}
        </ModelContext.Consumer>;
    }
}
export function mapStateToProps(state) {
    return {
        emptyFieldModel: state.alert.get('emptyFieldModel')
    };
}
export const RRFInput = connect<{}, {}, IRRFInputProps>(mapStateToProps)(RRFInputImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/FormComponents/RRFInput.tsx